import { Box, Grid, Typography } from '@mui/material'
import { UINewsTranslation } from '../../../../../utils'

interface NewsTabContentProps {
  item: UINewsTranslation
}

export const NewsTabContent = ({ item }: NewsTabContentProps) => {
  const { formattedStartDate, header, content } = item

  return (
    <Grid container spacing={2}>
      <Grid item md={7} xs={7}>
        <Typography
          sx={{
            fontWeight: 'bold'
          }}
          variant="subtitle1"
        >
          {header}
        </Typography>
      </Grid>
      <Grid item md={5} xs={5}>
        <Box sx={{ textAlign: 'right', color: '#707070', fontSize: '16px' }}>
          {formattedStartDate}
        </Box>
      </Grid>
      <Grid container item>
        <Typography sx={{ whiteSpace: 'pre-line' }}>{content}</Typography>
      </Grid>
    </Grid>
  )
}
